import { Image } from "@heroui/react";
import { getStaticAsset } from "core/model/config";
import { usePageMetaData } from "dsl/hooks";
import { AdmissionsFooter } from "../shared/AdmissionsFooter";

export function ErrorScreen({
  description,
  errorCode,
  imageAlt,
  title,
}: {
  errorCode?: string;
  title: string;
  description: string;
  imageAlt: string;
}) {
  usePageMetaData({
    title: (translations) =>
      translations.careproviderApp.recareAdmissionsForm.pageTitles
        .pageGenericError,
  });

  return (
    <main className="flex min-h-screen flex-col">
      <div className="mx-auto my-auto flex max-w-4xl flex-col items-center gap-8 text-gray-900 tablet:h-[200px] tablet:flex-row tablet:items-center tablet:gap-12">
        <div className="flex w-[300px] flex-col gap-8">
          {errorCode && <p className="text-body-lg">{errorCode}</p>}
          <h1 className="text-heading-3xl font-bold">{title}</h1>
          <p className="text-body-lg">{description}</p>
        </div>
        <Image
          alt={imageAlt}
          className="h-full overflow-visible"
          src={getStaticAsset("admissions-page-not-found.svg")}
        />
      </div>
      <AdmissionsFooter />
    </main>
  );
}
